<template>
    <div>
        <Form ref="awardTrophyForm" :model="awardTrophyForm" :rules="awardTrophyRules" label-position="top" class="fit-to-content">
            <Row :gutter="32" style="width: 800px;">
                <i-col :xs="8">
                    <FormItem prop="gameId" label="Game">
                        <Select v-model="awardTrophyForm.gameId" @on-change="gameChanged" placeholder="Select game">
                            <Option v-for="game in games" :value="game.id" :key="game.id">{{ game.gameRef.gameTitle}} - {{game.gameRef.author}}</Option>
                        </Select>
                        <Spin fix class="field-spinner" v-if="loadingGames">
                            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                        </Spin>
                    </FormItem>
                </i-col>
                <i-col :xs="8">
                    <FormItem prop="tournamentId" label="Tournament">
                        <Select v-model="awardTrophyForm.tournamentId" placeholder="Select tournament" @on-change="getTournamentTrophies">
                            <Option v-for="tournament in tournaments" :value="tournament._id" :key="tournament._id">{{ tournament.TournamentName}}</Option>
                        </Select>
                        <Spin fix class="field-spinner" v-if="loadingTournaments">
                            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                        </Spin>
                    </FormItem>
                </i-col>
                <i-col :xs="8">
                    <FormItem prop="trophyId" label="Trophy">
                        <Select v-model="awardTrophyForm.trophyId" placeholder="Select throphy">
                            <Option v-for="trophy in trophies" :value="trophy._id" :key="trophy._id">{{ trophy.TrophyName}}</Option>
                        </Select>
                        <Spin fix class="field-spinner" v-if="loadingTrophies">
                            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                        </Spin>
                    </FormItem>
                </i-col>
                <i-col :xs="24">
                    <Button type="primary"
                            :loading="submitLoading"
                            @click="createGameAwardTrophy"
                            style="margin-left: 8px">
                        <span v-if="!submitLoading">Award Trophy</span>
                        <span v-else>Processing...</span>
                    </Button>
                </i-col>
            </Row>
        </Form>
        <AwardTrophyList ref="AwardTrophyList" @updateAwardList="updateAwardList"></AwardTrophyList>
    </div>
</template>

<script>
    import {bus} from "../../main";
    import { getGames, addAwardTrophy } from "../../_services/game.service";
    import { getTournaments, getTournament } from "../../_services/tournament.service";
    import AwardTrophyList from "./AwardTrophyList"

    export default {
        data(){
            const validateTrophy = (rule, value, callback) => {
                    let duplicateName=this.awardTrophies.filter((award)=>{
                        return award.Tournament._id===this.awardTrophyForm.tournamentId && award.Trophy._id===value
                    })
                    if(duplicateName.length){
                        callback(new Error('Trophy already assigned for this tournament.'));
                    }else{
                        callback();
                    }

            };
            return{
                submitLoading:false,
                loadingGames:false,
                loadingTournaments:false,
                loadingTrophies:false,
                awardTrophyForm:{
                    gameId:null,
                    tournamentId:null,
                    trophyId:null
                },
                awardTrophyRules: {
                    gameId: [
                        {
                            required: true,
                            message: "Please select a game",
                            trigger: "change"
                        }
                    ],
                    tournamentId: [
                        {
                            required: true,
                            message: "Please select a tournament",
                            trigger: "change"
                        }
                    ],
                    trophyId: [
                        {
                            required: true,
                            message: "Please select a trophy",
                            trigger: "change"
                        },
                        { validator: validateTrophy, trigger: 'change' }
                    ],
                },
                games:[],
                tournaments: [],
                trophies:[],
                awardTrophies:[],
            }
        },
        components: {
            AwardTrophyList
        },
        methods: {
            getGameList(params){
                this.loadingGames=true
                getGames(params).then(res=>{
                    if(!params){
                        this.getGameList({Offset:0,MaxResults:res.data.data.total[0].count})
                    }else{
                        this.games=res.data.data.rows
                        this.loadingGames=false
                    }
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.loadingGames=false
                })
            },
            getTournamentList(){
                this.loadingTournaments=true
                getTournaments().then(res=>{
                    this.tournaments=res.data.data
                    this.loadingTournaments=false
                }).catch(err=>{
                    this.loadingTournaments=false
                })
            },
            getTournamentTrophies(id){
                this.$refs.awardTrophyForm.validateField('trophyId');
                this.loadingTrophies=true
                getTournament(id).then(res=>{
                    this.trophies=res.data.data.trophies
                    this.loadingTrophies=false
                }).catch(err=>{
                    this.loadingTrophies=false
                })
            },
            createGameAwardTrophy(){
                this.$refs.awardTrophyForm.validate(valid => {
                    if (valid) {
                        this.submitLoading=true
                        addAwardTrophy(this.awardTrophyForm).then(res=>{
                            this.$Message.success('Award trophy successfully added')
                            this.submitLoading=false
                            this.gameChanged()
                        }).catch(err=>{
                            bus.$emit('requestError',err)
                            this.$Message.error('Failed to add award trophy')
                            this.submitLoading=false
                        })
                    }
                });
            },
            gameChanged(){
                this.$refs.awardTrophyForm.validateField('tournamentId');
                this.$refs.awardTrophyForm.validateField('trophyId');
                let gameData=this.games.filter(({id})=>{
                    return id===this.awardTrophyForm.gameId
                })[0]
                this.$refs.AwardTrophyList.getGameTrophiesList(this.awardTrophyForm.gameId,gameData)
            },
            updateAwardList(data){
                this.awardTrophies=data
            }
        },
        mounted() {
            this.getGameList()
            this.getTournamentList()
        }
    };
</script>

<style scoped>
    .session-input{
        width: 300px;
    }
    .author{
        font-size: 12px;
        color: #dcdee2;
        font-style: italic;
        position: relative;
        margin-left: 16px;
    }
    .author:before{
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #dcdee2;
        position: absolute;
        top: calc(50% - 2px);
        left: -8px;
    }
</style>
